import {useParams} from "react-router";
import DomainNameShard from "../domain/DomainNameShard";

export default function Domain() {
    const {domainId} = useParams();
    return <DomainNameShard id={parseInt(domainId)} />;
}
